import angular, { IQService } from "angular";

import { vsName as processModuleName } from "../../../Process";
import {
  ProcessGroupConfig,
  configureDetailView,
  configureProcessGroup,
} from "../../../Process/config";
import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import { vsObjectName as contractObjectName } from "../../../Contract/configs/contract";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { vsProviderName as ContractDetailTabsServiceProviderName } from "../../../Contract/shared/components/views/contract/detail/tabs/contractDetailTabsService";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../../ui/authorizedUiElement";
import {
  SelectContractModalService,
  vsServiceName as SelectContractModalServiceName,
} from "../../../Contract/shared/components/selectContractModal";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../records/grids/controller";
import { ContractConfigurationView } from "../../../Contract/shared/models/contractConfiguration";
import { vsModuleName as contractSharedModuleName } from "../../../Contract/shared";
import {
  SelectMachineModalService,
  vsServiceName as SelectMachineModalServiceName,
} from "../../shared/components/selectMachineModal";

import { vsModuleName as selectMachineModalModuleName } from "../../shared/components/selectMachineModal";
import { vsObjectName as machineObjectName } from "../configs/machineConfiguration";
import {
  ProcessInformationServiceProvider,
  vsProviderName as ProcessInformationServiceProviderName,
  vsServiceName as ProcessInformationServiceName,
  ProcessInformationService,
} from "../../../Process/services/processInformationService";
import { ProcessInformation } from "../../../Process/model/ProcessGroups";

export const vsModuleName = "Slotcheck.DesertDiamond";

angular
  .module(vsModuleName, [
    processModuleName,
    contractSharedModuleName,
    selectMachineModalModuleName,
  ])
  .config([
    "$stateProvider",
    ContractDetailTabsServiceProviderName,
    "$injector",
    ProcessInformationServiceProviderName,
    (
      $stateProvider: StateProvider,
      contractDetailTabsServiceProvider: AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>,
      $injector: angular.auto.IInjectorService,
      processInformationServiceProvider: ProcessInformationServiceProvider
    ) => {
      const processDetailTemplate =
        require("!html-loader!./processDetail.html").default;

      const contractProcessGroupConfig: ProcessGroupConfig = {
        baseSref: "main.contract.process",
        getCreateProcessDto: [
          "dataObject",
          (dataObject) => {
            return { ContractId: dataObject.Id };
          },
        ],
        onSelectDataObject: [
          "$q",
          SelectContractModalServiceName,
          RecordGridViewServiceName,
          ColumnDefinitionServiceName,
          (
            $q: IQService,
            selectContractModalService: SelectContractModalService,
            recordGridViewService: RecordGridViewService,
            columnDefinitionService: ColumnDefinitionService
          ) =>
            openSelectContractModal(
              $q,
              selectContractModalService,
              recordGridViewService,
              columnDefinitionService
            ),
        ],
        processGroupName: contractObjectName,
        processDetailTemplate,
        additionalGridColumns: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) => {
            return (
              recordGridViewService.getGridConfiguration(contractObjectName)
                ?.columns ?? []
            );
          },
        ],
      };

      const machineProcessGroupConfig: ProcessGroupConfig = {
        baseSref: "main.machines.process",
        getCreateProcessDto: [
          "dataObject",
          (dataObject) => {
            return { MachineId: dataObject.MachineId };
          },
        ],
        onSelectDataObject: [
          "$q",
          SelectMachineModalServiceName,
          RecordGridViewServiceName,
          ColumnDefinitionServiceName,
          (
            $q: IQService,
            selectMachineModalService: SelectMachineModalService,
            recordGridViewService: RecordGridViewService,
            columnDefinitionService: ColumnDefinitionService
          ) =>
            openSelectMachineModal(
              $q,
              selectMachineModalService,
              recordGridViewService,
              columnDefinitionService
            ),
        ],
        processGroupName: "machine",
        processDetailTemplate: require("!html-loader!./machineDetail.html")
          .default,
        additionalGridColumns: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) => {
            return (
              recordGridViewService.getGridConfiguration(machineObjectName)
                ?.columns ?? []
            );
          },
        ],
      };

      configureContractProcessGroup(
        contractProcessGroupConfig,
        $stateProvider,
        processInformationServiceProvider
      );
      configureContractProcessTab(
        contractProcessGroupConfig,
        contractDetailTabsServiceProvider
      );
      configureMachineProcessGroup(
        machineProcessGroupConfig,
        $stateProvider,
        processInformationServiceProvider
      );
      if ($injector.has("machineDetailTabsServiceProvider")) {
        const machineDetailTabService = $injector.get<
          AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>
        >("machineDetailTabsServiceProvider");

        configureMachineProcessTab(
          machineProcessGroupConfig,
          machineDetailTabService
        );
      }
    },
  ]);

function configureContractProcessGroup(
  processGroupConfig: ProcessGroupConfig,
  $stateProvider: StateProvider,
  processInformationServiceProvider: ProcessInformationServiceProvider
) {
  configureProcessGroup(
    processGroupConfig,
    $stateProvider,
    processInformationServiceProvider
  );
}
function configureContractProcessTab(
  processGroupConfig: ProcessGroupConfig,
  contractDetailTabsServiceProvider: AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>
) {
  configureDetailView(
    processGroupConfig,
    contractDetailTabsServiceProvider,
    [
      "$stateParams",
      ($stateParams: StateParams) => {
        return { ContractId: $stateParams.contractId };
      },
    ],
    [
      "$stateParams",
      "$state",
      ProcessInformationServiceName,
      (
        $stateParams: StateParams,
        $state: StateService,
        processInformationService: ProcessInformationService
      ) => [
        "process",
        (process: ProcessInformation) =>
          processInformationService
            .createProcess(process, {
              ContractId: $stateParams.contractId,
            })
            .then((process) =>
              $state.go(".detail", { processInstancesId: process.Id })
            ),
      ],
    ]
  );
}
function openSelectContractModal(
  $q: IQService,
  selectContractModalService: SelectContractModalService,
  recordGridViewService: RecordGridViewService,
  columnDefinitionService: ColumnDefinitionService
) {
  const gridConfiguration =
    recordGridViewService.getGridConfiguration(contractObjectName)!;

  gridConfiguration.columns = [
    columnDefinitionService.getCommandColDef({
      headerName: "select",
      iconClass: "fa fa-plus-circle text-primary",
      name: "select",
    }),
    ...(gridConfiguration.columns ?? []),
  ];
  gridConfiguration.onItemCommand = (
    args: IRowCommandEventArgs<ContractConfigurationView>
  ) => {
    const { commandName, data: machineConfigurationView } = args;
    if (commandName === "select") {
      modalInstance.close(machineConfigurationView);
    }
    return $q.when();
  };

  const modalInstance = selectContractModalService.openModal({
    gridConfiguration,
  });
  return modalInstance.result.then((r) => <ContractConfigurationView>r);
}
function configureMachineProcessTab(
  processGroupConfig: ProcessGroupConfig,
  machineDetailTabsServiceProvider: AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig>
) {
  configureDetailView(
    processGroupConfig,
    machineDetailTabsServiceProvider,
    [
      "$stateParams",
      ($stateParams: StateParams) => {
        return { MachineId: $stateParams.machineId };
      },
    ],
    [
      "$stateParams",
      ProcessInformationServiceName,
      (
        $stateParams: StateParams,
        processInformationService: ProcessInformationService
      ) => [
        "process",
        (process: ProcessInformation) =>
          processInformationService.createProcess(process, {
            MachineId: $stateParams.machineId,
          }),
      ],
    ]
  );
}

function configureMachineProcessGroup(
  processGroupConfig: ProcessGroupConfig,
  $stateProvider: StateProvider,
  processInformationServiceProvider: ProcessInformationServiceProvider
) {
  configureProcessGroup(
    processGroupConfig,
    $stateProvider,
    processInformationServiceProvider
  );
}

function openSelectMachineModal(
  $q: IQService,
  selectMachineModalService: SelectMachineModalService,
  recordGridViewService: RecordGridViewService,
  columnDefinitionService: ColumnDefinitionService
) {
  const gridConfiguration =
    recordGridViewService.getGridConfiguration(machineObjectName)!;

  gridConfiguration.columns = [
    columnDefinitionService.getCommandColDef({
      headerName: "select",
      iconClass: "fa fa-plus-circle text-primary",
      name: "select",
    }),
    ...(gridConfiguration.columns ?? []),
  ];
  gridConfiguration.onItemCommand = (
    args: IRowCommandEventArgs<ContractConfigurationView>
  ) => {
    const { commandName, data: machineConfigurationView } = args;
    if (commandName === "select") {
      modalInstance.close(machineConfigurationView);
    }
    return $q.when();
  };

  const modalInstance = selectMachineModalService.openModal({
    gridConfiguration,
  });
  return modalInstance.result.then((r) => r);
}
